import React, { useState } from "react";
import Style from "./index.module.scss";
import Header from "components/Header";
import { Breadcrumb, Button, Card, Spin, Tooltip } from "antd";
import { useHistory, useParams } from "react-router-dom";
import useRequest from "utils/useRequest";
import { getNetCourseList, getNoWeekTimeCourseList } from "service/course";
import NavBar from "./components/NavBar";
import TeachAnalyse from "./components/TeachAnalyse";
import StudyAnalyse from "./components/StudyAnalyse";
import { BiUndo } from "react-icons/bi";
import {
    exportLearningInfo,
    getLearningInfos,
    getTeachingInfos
} from "service/report";

export default function PageAnalyse() {
    const { courseNo, courseSeq, id } = useParams<StringMap>();
    const history = useHistory();
    const [orderBy, setOrderBy] = useState("");
    const [mark, setMark] = useState<number>(1); //默认选中教学分析按钮

    const [courseList] = useRequest(() => getNoWeekTimeCourseList());
    const [data] = useRequest(() => getNetCourseList());
    const courseInfo = [...(data || []), ...(courseList || [])].filter(
        item => item.courseSeq === courseSeq && item.courseNo === courseNo
    )[0];
    const [teachReport, { loading }] = useRequest(
        () => getTeachingInfos(courseNo, courseSeq),
        {},
        [courseNo, courseSeq]
    );
    const [studyReport, { loading: studyReportLoading }] = useRequest(
        () => getLearningInfos(courseNo, courseSeq),
        {},
        [courseNo, courseSeq]
    );
    const title = (
        <div className={Style.head}>
            <div>
                <Tooltip title={courseInfo?.courseName} placement="bottomLeft">
                    <span className={Style.courseTitle}>
                        {courseInfo?.courseName}
                    </span>
                </Tooltip>
                <Button
                    size="small"
                    className={Style.goBack}
                    onClick={() => history.goBack()}>
                    <BiUndo size={16} />
                    返回
                </Button>
            </div>
            {mark === 2 && (
                <Button
                    className={Style.export}
                    type="primary"
                    ghost
                    onClick={() =>
                        exportLearningInfo(
                            courseNo,
                            courseSeq,
                            orderBy,
                            courseInfo.batchNo
                        )
                    }>
                    导出数据
                </Button>
            )}
        </div>
    );

    return (
        <div>
            <Header />

            <Spin spinning={loading && studyReportLoading}>
                <div className={Style.root}>
                    <Breadcrumb separator=">">
                        <Breadcrumb.Item href="/">首页</Breadcrumb.Item>
                        {id && (
                            <Breadcrumb.Item>
                                <a onClick={() => history.goBack()}>课程内容</a>
                            </Breadcrumb.Item>
                        )}
                        <Breadcrumb.Item>
                            <a href="">课程分析</a>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Card
                        title={title}
                        bordered={false}
                        className={Style.container}>
                        <div className={Style.head}>
                            <div className={Style.subTitle}>
                                <span>编号 {courseNo}</span>
                                <span>序号 {courseSeq}</span>
                                {teachReport &&
                                    teachReport.classHour !== null &&
                                    teachReport.classHour !== 0 && (
                                        <span>
                                            总学时 {teachReport?.classHour}
                                        </span>
                                    )}
                            </div>
                        </div>

                        <NavBar
                            mark={mark}
                            onChange={(val: number) => setMark(val)}
                        />

                        <div className={Style.content}>
                            {/* {mark === 0 && <TeachLog/>} */}
                            {teachReport && mark === 1 && (
                                <TeachAnalyse data={teachReport} />
                            )}
                            {studyReport && mark === 2 && (
                                <StudyAnalyse
                                    onsorter={setOrderBy}
                                    data={studyReport}
                                />
                            )}
                        </div>
                    </Card>
                </div>
            </Spin>
        </div>
    );
}
